import { render, staticRenderFns } from "./EmployeeSalaryModal.vue?vue&type=template&id=4152c320&"
import script from "./EmployeeSalaryModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports